import { SubscriptionActions } from '../../types/subscriptions';
import { CancellationModal } from '../cancellation/CancellationModal';
import { EditNextPaymentDateModal } from '../edit-next-payment-date/EditNextPaymentDateModal';
import { EditModal } from '../edit/EditModal';
import { PauseModal } from '../pause/PauseModal';
import { UpdatePaymentMethodModal } from '../update-payment-method/UpdatePaymentMethodModal';
import { ModalErrorBoundary } from './ModalErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export function ActionModal({
  objectId,
  actionType,
  actions,
  refetchStaleData
}) {
  switch (actionType) {
    case SubscriptionActions.Cancel:
      {
        return actions[actionType].isOpen ? /*#__PURE__*/_jsx(ModalErrorBoundary, {
          actions: actions[actionType],
          children: /*#__PURE__*/_jsx(CancellationModal, {
            objectId: objectId,
            actions: actions[actionType]
          })
        }) : null;
      }
    case SubscriptionActions.Edit:
      {
        return /*#__PURE__*/_jsx(EditModal, {
          actions: actions[actionType],
          refetchStaleData: refetchStaleData
        });
      }
    case SubscriptionActions.EditNextPaymentDate:
    case SubscriptionActions.EditNextBillingDate:
      {
        return actions[actionType].isOpen ? /*#__PURE__*/_jsx(ModalErrorBoundary, {
          actions: actions[actionType],
          children: /*#__PURE__*/_jsx(EditNextPaymentDateModal, {
            objectId: objectId,
            actions: actions[actionType],
            refetchStaleData: refetchStaleData
          })
        }) : null;
      }
    case SubscriptionActions.UpdatePaymentMethod:
      {
        return actions[actionType].isOpen ? /*#__PURE__*/_jsx(ModalErrorBoundary, {
          actions: actions[actionType],
          children: /*#__PURE__*/_jsx(UpdatePaymentMethodModal, {
            objectId: objectId,
            actions: actions[actionType]
          })
        }) : null;
      }
    case SubscriptionActions.Pause:
      {
        return actions[actionType].isOpen ? /*#__PURE__*/_jsx(ModalErrorBoundary, {
          actions: actions[actionType],
          children: /*#__PURE__*/_jsx(PauseModal, {
            objectId: objectId,
            actions: actions[actionType]
          })
        }) : null;
      }
    default:
      return null;
  }
}